import React from 'react';
import {isRTL} from '../../../../Localization';
import {
    PopoverPlacement,
    Flex,
    Button,
    Popover,
    Text,
    Title
} from '@priority-software/priority-style-react';
import styles from '../../styles.module.scss';
import texts from '../../texts';
import {sendMonitor} from '../../../../utils/monitoring';
import {createDataTestId} from '../../../../utils/dataTestId';

type Props = {
    isOpen: boolean;
    showSkipDialog: () => void;
    startOnboarding: () => void;
    onClose: () => void;
};

export const ContinueOnboardingPopover = (props: Props) => {
    const {isOpen, startOnboarding, showSkipDialog, onClose} = props;

    const onSkipDialog = () => {
        sendMonitor('OnboardingContinueNo');
        showSkipDialog();
    };

    const onContinueOnboarding = () => {
        sendMonitor('OnboardingContinueYes');
        startOnboarding();
    };

    return (
        <Popover
            {...createDataTestId('popover-continue-container', true)}
            content={
                <Text
                    tag="p"
                    textColor="primary-700"
                    skin="paragraph-2"
                    fontWeight="normal"
                    {...createDataTestId('popover-continue-text', true)}
                >
                    {texts.onboarding_continue_msg}
                </Text>
            }
            footer={() => (
                <Flex justifyContent="space-between" alignItems="center">
                    <Button
                        componentClasses={styles.btn}
                        size="large"
                        onClick={onSkipDialog}
                        skin="text"
                    >
                        {texts.welcome_skip_label}
                    </Button>

                    <Button
                        autoFocus={true}
                        componentClasses={styles.btn}
                        size="small"
                        onClick={onContinueOnboarding}
                        skin="primary"
                    >
                        {texts.onboarding_continue_action_primary}
                    </Button>
                </Flex>
            )}
            anchor={document.getElementById('companyName')}
            title={
                <Title
                    dataTestId="popover-continue-title"
                    skin="h5"
                    textColor="primary-700"
                    text={texts.onboarding_continue_title}
                />
            }
            hoverable={false}
            placement={isRTL() ? PopoverPlacement.rightStart : PopoverPlacement.leftStart}
            rtl={isRTL()}
            onClose={onClose}
            show={isOpen}
            outsideClickClose={false}
            closable
        />
    );
};
